let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fU3WR")).then(() => parcelRequire('6F1or'));